import { FlakinessReport } from '@flakiness/flakiness-report';
import { consume, ContextType } from '@lit/context';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { contexts } from '../contexts.js';
import { forgeUtils } from '../forgeUtils.js';
import { linkStyles } from './cssstyles.js';

/**
 * Links to the forge a project's source lives on. For links pointing anywhere
 * else - CI run logs, say - use `a-ext` instead.
 */
@customElement('forge-link')
class ForgeLink extends LitElement {
  @consume({ context: contexts.project, subscribe: true }) private _project?: ContextType<typeof contexts.project>;

  @property({ attribute: false }) pr?: string;
  @property({ attribute: false }) commitId?: FlakinessReport.CommitId;

  render() {
    let href: string|typeof nothing = nothing;
    if (forgeUtils.hasSourceUrl(this._project)) {
      if (this.pr)
        href = forgeUtils.pullRequestUrl(this._project, this.pr)
      else if (this.commitId)
        href = forgeUtils.commitUrl(this._project, this.commitId)
    }
    return html`
      <a href=${href} target=_blank>
        <sl-icon name=${forgeUtils.providerIcon(this._project)}></sl-icon>
        <span>${forgeUtils.providerName(this._project)}</span>
        <sl-icon library=boxicons name=bx-link-external></sl-icon>
      </a>
    `;
  }

  static styles = [linkStyles, css`
    :host {
      display: inline-block;
    }

    span {
      font-weight: var(--sl-font-weight-bold);
    }

    a {
      opacity: 0.5;
      --color: var(--sl-color-neutral-800);

      display: flex;
      align-items: center;
      gap: var(--sl-spacing-2x-small);
      color: var(--color) !important;
    }

    a:hover {
      
      opacity: 1;
    }

    sl-icon {
      flex: none;
    }
  `];
}
